module.exports = __webpack_public_path__ + "static/media/sheepFemale.4df5be6b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sheepFemale.svg
// module id = 377
// module chunks = 0